module.exports = __webpack_public_path__ + "static/media/ic_picture.63cd888c.png";